<script setup lang="ts">
import Toolbar from '@/components/toolbar/index.vue'
import type { Values } from '@/composables/useValues'

defineProps<{
    dimension?: Dimension
    data: Values
}>()

/**
 * Use framework.
 */
const { isImportingRisk } = useFramework()
</script>

<template>
    <Toolbar :data="data">
        <ToolbarRanking :data="data" :dimension="dimension" />

        <ToolbarImportProducts
            :data="data as unknown as Values<Import>"
            :dimension="dimension"
            only-top-five
        />

        <ToolbarToggleImportsByProduct :dimension="dimension" />

        <ToolbarPrevalenceUnit :dimension="dimension" />

        <ToolbarCompareCountry
            v-if="!isImportingRisk(dimension)"
            :data="data"
        />
    </Toolbar>
</template>